<template>
  <main-layout>
    <base-header>
      <template #icon> mdi-file</template>
      <template #name> Create Purchase Order</template>
      <template #breadcrumbs>
        <v-breadcrumbs :items="breadcrumbs" class="pa-0">
          <template #divider>
            <v-icon>mdi-chevron-right</v-icon>
          </template>
        </v-breadcrumbs>
      </template>
    </base-header>

    <v-card class="mx-1">
      <!-- App Bar -->
      <v-app-bar flat dense color="rgba(0, 0, 0, 0)">
        <v-toolbar-title>Purchase Order Information</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small color="secondary" class="ma-2" @click="backForm()">
          <v-icon>mdi-arrow-left</v-icon> Back
        </v-btn>
        <v-btn small color="secondary" class="ma-2" @click="clearForm()">
          Clear
          <v-icon>mdi-close-circle-multiple </v-icon>
        </v-btn>
        <v-btn small class="ma-2" color="primary" @click.stop="store" :loading="btnLoading"
          :disabled="!form_valid || btnLoading">
          Save
          <v-icon right>mdi-content-save-all</v-icon>
        </v-btn>
      </v-app-bar>
      <v-form ref="PurchaseOrder" v-model="form_valid" lazy-validation>
        <form-purchase-order />
        <form-item />
      </v-form>
    </v-card>
  </main-layout>
</template>

<script>
import Form from "./Form.vue";
import FormItem from "./FormItem.vue";
import MainLayout from "@/layouts/MainLayout.vue";
import BaseHeader from "@/components/base/BaseHeader.vue";
import { mapMutations } from "vuex";
export default {
  name: "PurchaseOrderCreate",

  data() {
    return {
      btnLoading: false,
      form_valid: true,
    };
  },
  created() {
    this.breadcrumbs = [
      { text: "Transaction", disabled: false },
      { text: "Purchase Order", disabled: true },
      { text: "Create", disabled: true },
    ];
  },

  methods: {
    ...mapMutations("purchase_order", ["CLEAR_STATE"]),
    store: async function () {
      if (this.$refs.PurchaseOrder.validate()) {
        // this.btnLoading = true;
        this.PurchaseOrder.sub_total = this.PurchaseOrder.details.reduce(
          (acc, cur) => acc + cur.total,
          0
        );
        this.PurchaseOrder.discount = parseFloat(this.PurchaseOrder.sub_total) * parseFloat(this.PurchaseOrder.discount_percent) / 100;
        this.PurchaseOrder.afterDiscount = parseFloat(this.PurchaseOrder.sub_total - this.PurchaseOrder.discount);
        if (this.PurchaseOrder.use_vat == true) {
          this.PurchaseOrder.vat = parseFloat((this.PurchaseOrder.afterDiscount * 11)) / 100;
        } else {
          this.PurchaseOrder.vat = 0;
        }
        this.PurchaseOrder.grand_total = parseFloat(this.PurchaseOrder.afterDiscount) + parseFloat(this.PurchaseOrder.vat);
        await this.$axios
          .post("/transaction/purchases", this.PurchaseOrder,
            {
              headers: { Authorization: this.$store.getters["auth/Token"] },
            })
          .then(() => {
            this.btnLoading = false;
            this.$router.push({ name: "purchase-order.index" });
          })
          .catch(() => {
            this.btnLoading = false;
          });
      }
    },

    backForm() {
      this.CLEAR_STATE();
      this.$router.push({ name: "purchase-order.index" });
    },

    clearForm() {
      this.CLEAR_STATE();
    },
  },
  computed: {
    PurchaseOrder() {
      return this.$store.getters["purchase_order/PurchaseOrder"];
    },
  },

  components: {
    MainLayout,
    BaseHeader,
    "form-purchase-order": Form,
    "form-item": FormItem,
  },
};
</script>
